const RRRFetch = (() => {
    let headersCached = {};
    let fetchCompleteCallback;
    let onUnauthorized;
    let unAuthorizedPromise;
    const setHeaders = (headers) => {
        headersCached = headers;
    };
    const setOnUnauthorized = (callback) => {
        onUnauthorized = callback;
    };
    const onFetchComplete = (callback) => {
        fetchCompleteCallback = callback;
    };
    const offFetchComplete = () => {
        fetchCompleteCallback = undefined;
    };
    const fetchCall = async (url, init) => {
        let errorCode = 0;
        let error = {
            message: 'Unknown Error',
        };
        try {
            let response = await fetch(url, {
                ...init,
                headers: new Headers({
                    ...init?.headers,
                    ...headersCached,
                }),
            });
            let status = response.status;
            if (status === 401) {
                if (onUnauthorized && !unAuthorizedPromise) {
                    unAuthorizedPromise = onUnauthorized();
                }
                if (unAuthorizedPromise) {
                    const { retry, statusOverride } = await unAuthorizedPromise;
                    if (retry) {
                        response = await fetch(url, {
                            ...init,
                            headers: new Headers({
                                ...init?.headers,
                                ...headersCached,
                            }),
                        });
                        status = response.status;
                    }
                    else if (statusOverride !== undefined) {
                        status = statusOverride;
                    }
                    unAuthorizedPromise = undefined;
                }
            }
            try {
                const json = await response.json();
                if (status >= 200 && status < 400 && 'value' in json) {
                    if (fetchCompleteCallback) {
                        fetchCompleteCallback({
                            code: status,
                        });
                    }
                    return {
                        code: status,
                        data: json.value,
                        permissions: json.permissions,
                    };
                }
                errorCode = status;
                if ('error' in json &&
                    typeof json.error === 'object' &&
                    json.error !== null &&
                    !Array.isArray(json.error)) {
                    const err = json.error;
                    error = {
                        message: 'message' in err && typeof err.message === 'string'
                            ? err.message
                            : 'Unspecified Error Message',
                        ...err,
                    };
                }
                else {
                    error = {
                        message: 'Unspecified Error',
                    };
                }
            }
            catch (e) {
                const err = e;
                errorCode = status;
                error = {
                    message: err.message || 'JSON parsing failed',
                };
            }
        }
        catch (e) {
            const err = e;
            errorCode = 0;
            error = {
                message: err.message || 'Fetch failed',
            };
        }
        if (fetchCompleteCallback) {
            fetchCompleteCallback({
                code: errorCode,
                error,
            });
        }
        throw {
            code: errorCode,
            error,
        };
    };
    return {
        setHeaders,
        setOnUnauthorized,
        onFetchComplete,
        offFetchComplete,
        fetch: fetchCall,
    };
})();
export default RRRFetch;
//# sourceMappingURL=fetch.js.map